import React from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import classNames from 'classnames';
import ChangeShashokuOptionDialog from '../molecules/ChangeShashokuOptionDialog';

const styles = {
  fixedWidthButton: {
    width: 210,
    padding: '0px 0px 6px 0px',
    whiteSpace: 'normal',
    textAlign: 'left',
    justifyContent: 'space-between',
    borderRadius: 0,
    borderBottom: '1px solid rgba(0, 0, 0, 0.42)'
  },
  disabledButton: {
    borderBottomStyle: 'dotted'
  },
  rightIcon: {
    color: 'rgba(0, 0, 0, 0.54)'
  },
  disabledIcon: {
    color: 'rgba(0, 0, 0, 0.26)'
  }
};

const enhance = compose(
  withState('gochimeshiFlag', 'setGochimeshiFlag', 0),
  withState('shashokuFlag', 'setShashokuFlag', 0),
  withState('gochiKidFlag', 'setGochiKidFlag', 0),
  withState('openChange', 'updateOpenChange', false),
  withState('openChangeConfirm', 'updateOpenChangeConfirm', false)
);

const button = enhance(
  ({
    classes,
    className,
    buttonClassName,
    openChange,
    disabled,
    updateOpenChange,
    params,
    onClickAction,
    gochimeshiFlag,
    setGochimeshiFlag,
    shashokuFlag,
    setShashokuFlag,
    gochiKidFlag,
    setGochiKidFlag,
    openChangeConfirm,
    updateOpenChangeConfirm,
    titleStatus
  }) => {
    const cancelAction = () => updateOpenChange(false);
    const changeAction = paramChange => {
      const param = {
        menuId: paramChange.id,
        gochimeshiFlag,
        shashokuFlag
      };
      updateOpenChange(false);
      updateOpenChangeConfirm(false);
      onClickAction(param);
    };
    const updateChange = () => {
      updateOpenChange(true);
      setGochimeshiFlag(params.gochimeshiFlag);
      setShashokuFlag(params.shashokuFlag);
      setGochiKidFlag(params.gochiKidFlag);
    };
    let disableStatus = false;
    if (params.disabled) {
      disableStatus = true;
    }
    return (
      <div className={className}>
        <Button
          variant="text"
          className={classNames(
            classes.fixedWidthButton,
            disabled && classes.disabledButton,
            buttonClassName
          )}
          disabled={disabled}
          onClick={() => updateChange(true)}
        >
          {titleStatus}
          <ArrowDropDown
            className={classNames(
              classes.rightIcon,
              disabled && classes.disabledIcon
            )}
          />
        </Button>
        <ChangeShashokuOptionDialog
          openChange={openChange}
          updateOpenChange={updateOpenChange}
          cancelAction={cancelAction}
          changeAction={() => changeAction(params)}
          target="Change"
          gochimeshiFlag={gochimeshiFlag}
          setGochimeshiFlag={setGochimeshiFlag}
          shashokuFlag={shashokuFlag}
          setShashokuFlag={setShashokuFlag}
          gochiKidFlag={gochiKidFlag}
          setGochiKidFlag={setGochiKidFlag}
          disableStatus={disableStatus}
          openChangeConfirm={openChangeConfirm}
          updateOpenChangeConfirm={updateOpenChangeConfirm}
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
